export default {
  bag: {
    setBagCount: 'header:setBagCount',
    increaseBagCount: 'header:updateBagCount',
  },
};
